module.exports = __webpack_public_path__ + "05909244aa07e613ee2e74db6a3e7e8b.pdf";